module.exports = __webpack_public_path__ + "img/eye_close.769037a9.svg";